var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36781_75878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00562 12C5.39293 12 4.78587 11.8215 4.30808 11.47L1.89106 9.38863C1.25027 8.91437 0.75 7.92123 0.75 7.13453V3.27374C0.75 2.41451 1.38517 1.49948 2.20021 1.19819L5.00509 0.15483C5.56156 -0.0516099 6.43844 -0.0516099 6.99492 0.15483L9.79979 1.19819C10.6148 1.49948 11.25 2.41451 11.25 3.27374V7.12895C11.25 7.92123 10.7497 8.90879 10.1089 9.38305L7.69192 11.4644C7.22538 11.8215 6.61831 12 6.00562 12Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48726 7.17622H6.48287L6.5172 6.80716C6.53436 6.50676 6.87768 6.24928 7.22099 5.92313C7.60722 5.55407 7.98486 5.10776 7.98486 4.4383C7.98486 3.31395 7.12658 2.76465 6.1653 2.76465C5.45293 2.76465 4.80063 3.07363 4.40582 3.55427L5.22119 4.30097C5.42718 4.01774 5.75333 3.8375 6.07947 3.8375C6.48287 3.8375 6.75752 4.07782 6.75752 4.50696C6.75752 4.89319 6.48287 5.20217 6.2168 5.49399C5.8649 5.85447 5.47868 6.20636 5.48726 6.74708V7.17622ZM6.01081 9.2361C6.38846 9.2361 6.70602 8.92712 6.70602 8.54089C6.70602 8.16325 6.38846 7.85427 6.01081 7.85427C5.616 7.85427 5.29844 8.16325 5.29844 8.54089C5.29844 8.92712 5.616 9.2361 6.01081 9.2361Z",
    fill: "#202124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36781_75878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldUnknown);
export default __webpack_public_path__ + "static/media/shield-unknown.b12b004756eb9d5a50ea9faf9181467d.svg";
export { ForwardRef as ReactComponent };